export default "__VITE_ASSET__pePF1no3__"